module.exports = __webpack_public_path__ + "static/media/code128.8ffedc82.ttf";